export function request(body) {
    return {
        type: 'UPDATE_BANNER_REQUEST',
        body
    };
}

export function error(errors) {
    return {
        type: 'UPDATE_BANNER_ERROR',
        errors
    };
}

export function finish(data) {
    return {
        type: 'UPDATE_BANNER_FINISH',
        data
    };
}
